import z from 'zod'
import { GeometrySchema } from '../../../@shared/infra/schemas/Geometry.schema'
import { ExclusionZone } from '../../domain/entities/ExclusionZone'

export const ExclusionZoneSchema = z
	.object({
		id: z.uuid(),
		codigo: z.number(),
		nome: z.string(),
		descricao: z.string(),
		id_area_monitorada: z.string(),
		nome_area_monitorada: z.string(),
		geometrias: z.preprocess((value: string[]) => {
			const parsed = value.map((v) => GeometrySchema.parse(JSON.parse(v)))
			return parsed
		}, z.array(GeometrySchema)),
	})
	.transform((data) => {
		return new ExclusionZone(
			data.nome,
			data.descricao,
			data.id_area_monitorada,
			data.nome_area_monitorada,
			data.geometrias,
			data.codigo,
			data.id,
		)
	})
